import { useCallback, useEffect, useState } from "react";

import {
  type DashboardSchemaTelemetryScopeSummaryResponse,
  getSchemaTelemetryScopeSummaryAsUser,
} from "../dashboard-client";

export function useSchemaTelemetryScopeSummary(
  scopeType: string | null,
  scopeId: string | null,
  enabled: boolean,
) {
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);
  const [data, setData] =
    useState<DashboardSchemaTelemetryScopeSummaryResponse | null>(null);

  const fetchNow = useCallback(async () => {
    if (!enabled || !scopeType || !scopeId) {
      setData(null);
      setFetchError(null);
      return;
    }

    setLoading(true);
    setFetchError(null);
    try {
      const { data: result } = await getSchemaTelemetryScopeSummaryAsUser({
        query: { scopeId, scopeType },
      });
      setData(result);
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      setFetchError(message);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, scopeType, scopeId]);

  useEffect(() => {
    void fetchNow();
  }, [fetchNow]);

  return { data, error: fetchError, loading, refetch: fetchNow };
}
